import { useTranslation } from 'react-i18next';
import { MfaSection } from './MfaSection';
import { useAuthStore } from '../../stores/auth-store';

export function SettingsPage() {
  const { t } = useTranslation();
  const user = useAuthStore((s) => s.user);

  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-semibold text-slate-900">{t('settings.title')}</h2>
      <p className="text-sm text-slate-600">
        {t('settings.subtitle', { email: user?.email ?? '' })}
      </p>
      <MfaSection />
    </div>
  );
}
